<ng-container *ngIf="!item.hidden">
  <li [ngClass]="item.classes!" *ngIf="item.url && !item.external" [routerLinkActive]="['active']">
    <a class="nav-link" [target]="item.target ? '_blank' : '_self'" [routerLink]="[item.url]" (click)="toggleMenu($event)">
      <ng-container *ngTemplateOutlet="itemIcon"></ng-container>
      <span class="coded-mtext" *ngIf="item.icon; else directTitle">{{ item.title | translate }}</span>
      <ng-template #directTitle>
        {{ item.title | translate }}
      </ng-template>
      <ng-container *ngTemplateOutlet="itemBadge"></ng-container>
    </a>
  </li>
  <li [ngClass]="item.classes!" *ngIf="item.url && item.external">
    <a [target]="item.target ? '_blank' : '_self'" [routerLinkActive]="item.url">
      <ng-container *ngTemplateOutlet="itemIcon"></ng-container>
      <span class="coded-mtext" *ngIf="item.icon; else directTitle">{{ item.title | translate }}</span>
      <ng-template #directTitle>
        {{ item.title }}
      </ng-template>
      <ng-container *ngTemplateOutlet="itemBadge"></ng-container>
    </a>
  </li>
  <ng-template #itemIcon>
    <span *ngIf="item.icon" class="coded-micon">
      <svg class="pc-icon">
        <use attr.xlink:href="assets/fonts/custom-icon.svg{{ item.icon }}"></use>
      </svg>
    </span>
  </ng-template>
  <ng-template #itemBadge>
    <span *ngIf="item.badge" class="coded-badge label" [ngClass]="item.badge.type!">
      {{ item.badge.title }}
    </span>
  </ng-template>
</ng-container>
